module.exports = "<div class=\"gw-claims-view gw-page gw-box\">\r\n    <h1 class=\"gw-page-title\">{{&apos;claim.views.claims.Claims&apos; | translate }}</h1>\r\n\r\n    <div gw-claim-claim-summary=\"\" class=\"gw-claim-summary\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/has-text?role!./common/js/src/edge/claim/views/claims.html
// module id = 495
// module chunks = 0